import { AddEdit } from '../../../../interfaces/user.interface';
import { Validation } from '../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
  Regex,
} from '../../../../utils/appConstant';

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.firstName) {
    if (!formData.firstName?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.firstName,
        message: APP_ERROR_MESSAGES.users.addEdit.blankFirstName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.lastName) {
    if (!formData.lastName?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.lastName,
        message: APP_ERROR_MESSAGES.users.addEdit.blankLastName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (!formData.email?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.users.addEdit.blankEmail,
      });
    } else if (!Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.users.addEdit.invalidEmail,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.phone) {
    if (!formData.phone?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.phone,
        message: APP_ERROR_MESSAGES.users.addEdit.blankPhoneNumber,
      });
    } else if (formData.phone.replace(/\s/g, '').length !== 10) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.phone,
        message: APP_ERROR_MESSAGES.login.invalidPhoneNumber,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.role) {
    if (!formData.role) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.role,
        message: APP_ERROR_MESSAGES.users.addEdit.blankRole,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.countryId) {
    if (!formData.countryId) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.countryId,
        message: APP_ERROR_MESSAGES.users.addEdit.blankCountry,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.stateId) {
    if (!formData.stateId) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.stateId,
        message: APP_ERROR_MESSAGES.users.addEdit.blankState,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.cityId) {
    if (!formData.cityId || formData.cityId.length === 0) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.cityId,
        message: APP_ERROR_MESSAGES.users.addEdit.blankCity,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.area) {
    if (!formData.area || formData.area.length === 0) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.area,
        message: APP_ERROR_MESSAGES.users.addEdit.blankArea,
      });
    }
  }

  // Company fields validation (optional but validate format if provided)
  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.companyName) {
    if (formData.companyName && !formData.companyName.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.companyName,
        message: APP_ERROR_MESSAGES.users.addEdit.blankCompanyName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.companyContactNumber) {
    if (formData.companyContactNumber && !formData.companyContactNumber.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.companyContactNumber,
        message: APP_ERROR_MESSAGES.users.addEdit.blankCompanyContactNumber,
      });
    } else if (formData.companyContactNumber && formData.companyContactNumber.replace(/\s/g, '').length !== 10) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.companyContactNumber,
        message: APP_ERROR_MESSAGES.login.invalidPhoneNumber,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.companyAddressLine1) {
    if (formData.companyAddressLine1 && !formData.companyAddressLine1.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.companyAddressLine1,
        message: APP_ERROR_MESSAGES.users.addEdit.blankCompanyAddressLine1,
      });
    }
  }

  return validations;
};
